import { render, staticRenderFns } from "./batch-remove-button.vue?vue&type=template&id=0571064c&scoped=true&"
import script from "./batch-remove-button.vue?vue&type=script&lang=js&"
export * from "./batch-remove-button.vue?vue&type=script&lang=js&"
import style0 from "./batch-remove-button.vue?vue&type=style&index=0&id=0571064c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0571064c",
  null
  
)

export default component.exports